// extracted by mini-css-extract-plugin
module.exports = {"home":"Homepage_home__ubsEX"};